import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import LeadsGenPOCsPage from 'src/pages/LeadsGenPOCPage';

const LeadGenRoutes = () => {
	return (
		<Routes>
			<Route path="/leads-gen" element={<LeadsGenPOCsPage />} />
			<Route path="*" element={<Navigate to="/leads-gen" />} />
		</Routes>
	);
};

export default LeadGenRoutes;
